import http from 'hub-http/clients/noAuthApiClient';
import { getFullUrl } from 'hubspot-url-utils';
import quickFetch from 'quick-fetch';
import { PUBLIC_META } from '../constants/EarlyRequesterNames';
import { getPreferredLanguage } from '../utils/getPreferredLanguage';
import { getIsQAProxy } from '../utils/proxyUtils';
const fetchPublicMetaData = () => {
  // This logic and code should be kept consistent with publicEarlyRequester.js
  const preferredLanguage = getPreferredLanguage();
  let publicMetaUrl = 'monetization/v3/public-pricing';
  if (preferredLanguage) {
    publicMetaUrl = `${publicMetaUrl}/${preferredLanguage.toLowerCase()}`;
  }
  const isInIndia = window.location.host.indexOf('hubspot.in') > -1;
  const preferredCountry = isInIndia ? 'in' : window.COUNTRY_CODE_FROM_LOCALE && window.COUNTRY_CODE_FROM_LOCALE.toUpperCase();
  if (preferredCountry) {
    publicMetaUrl = `${publicMetaUrl}?preferredCountry=${preferredCountry}`;
  }
  publicMetaUrl = `${getFullUrl('app-api', getIsQAProxy() ? {
    envOverride: 'qa'
  } : {})}/${publicMetaUrl}`;
  return http.get(publicMetaUrl);
};

// Quick fetched, check publicEarlyRequester.js
export const getPublicMetaData = () => {
  const earlyRequest = quickFetch.getRequestStateByName(PUBLIC_META);
  if (earlyRequest) {
    return new Promise((resolve, reject) => {
      earlyRequest.whenFinished(result => {
        resolve(result);
        quickFetch.removeEarlyRequest(PUBLIC_META);
      });
      earlyRequest.onError(() => {
        fetchPublicMetaData().then(resolve).catch(error => {
          reject(error);
        });
        quickFetch.removeEarlyRequest(PUBLIC_META);
      });
    });
  } else {
    return fetchPublicMetaData();
  }
};